import { render, staticRenderFns } from "./CategorySelectInput.vue?vue&type=template&id=02ec84dc&"
import script from "./CategorySelectInput.vue?vue&type=script&lang=js&"
export * from "./CategorySelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports